import React from 'react';
import Fab from '@mui/material/Fab';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const WhatsAppFab = () => (
  <Fab
    href="https://wa.me/584122373053"
    target="_blank"
    sx={{
      position: 'fixed',
      bottom: 64,
      right: 16,
      bgcolor: '#25D366',
      color: '#fff',
      '&:hover': { bgcolor: '#1ebe5b' },
      boxShadow: 6,
    }}
  >
    <WhatsAppIcon fontSize="large" />
  </Fab>
);

export default WhatsAppFab;